<template>
  <div class="d-flex justify-content-center align-items-center flex-column">
    <div class="row">
      <template v-if="step === 1">
        <div class="col-12 col-md-12 mt-2">
          <button @click="_selectService('club')" class="btn btn-block btn-payment btn-dark">
            <h3>Business Club</h3>
          </button>
        </div>
        <div class="col-12 col-md-12 mt-2">
          <button @click="_selectService('lupe_token')" class="btn btn-block btn-payment btn-dark">
            <h3>Lupe Token</h3>
          </button>
        </div>
        <div class="col-12 col-md-12 mt-2">
          <button @click="_selectService('lupe_lotto')" class="btn btn-block btn-payment btn-dark">
            <h3>Lupe Lotto</h3>
          </button>
        </div>
      </template>
      <template v-else>
        <div class="col-12 col-md-12 mt-2">
          <button @click="_selectMethod(16)" class="btn btn-block btn-payment btn-dark">
            <div class="crypto-icon-container">
              <cryptoicon :symbol="'usdt'" class="btn-img" />

              <div class="network-badge">
                <cryptoicon :symbol="'trx'" class="btn-img" color="red" />
              </div>
            </div>
            <h3>USDT (TRON)</h3>
          </button>
        </div>

        <div class="col-12 col-md-12 mt-2">
          <button @click="_selectMethod(17)" class="btn btn-block btn-payment btn-dark">
            <div class="crypto-icon-container">
              <cryptoicon :symbol="'usdt'" class="btn-img" />

              <div class="network-badge">
                <cryptoicon :symbol="'bnb'" class="btn-img" />
              </div>
            </div>
            <h3>USDT (BNB Smart Chain)</h3>
          </button>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-payment {
  background: unset;
}

.btn-img {
  height: 12rem !important;
  width: 12rem !important;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.crypto-icon-container {
  position: relative;
  display: inline-block;
}

.network-badge {
  position: absolute;
  bottom: 1.5rem;
  right: 0;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  border: 3px solid #2c2c3e;
  background-color: #ffffff;
}

.network-badge-bnb {
  background-color: #f0b90b;
  color: #000;
}

.network-badge-tron {
  background-color: #eb0029;
}
</style>

<script>
export default {
  name: "payment-method",
  data() {
    return { step: 2 }; // SET to 2 to avoid showing service selection initially - directly show payment methods
  },
  beforeDestroy() {
    this.reset();
  },
  methods: {
    _selectService(service) {
      this.$emit("service", service);
      this.$emit("title", "2. Select a payment method to continue");

      this.step = 2;
    },
    reset() {
      this.step = 1;
    },
    _selectMethod(methodId) {
      this.$emit("selected", methodId);
      this.$emit("title", "2. Enter Payment Details");
    },
  },
};
</script>
